import React from 'react';
const Header = (props)=>(
  <React.Fragment>
  <header>
      <div className="custom-container"><p>Email <a href="mailto:info@firerecoveryusa.com">info@firerecoveryusa.com</a> or Call Us For Assistance 1-888-640-7222</p></div>
  </header>
  </React.Fragment>
);
export default Header;
